import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useCreatePanelist = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const createPanelistHook = async (panelist, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-event-panelist/v1/create/`,
        {panelist}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to create Panelist");
      }
    } catch (error) {
      setError("An error occurred while creating Panelist");
    } finally {
      setLoading(false);
    }
  };

  return [ createPanelistHook, loading, error, success ];
};